import * as types from '../actions/ActionTypes.js';

const dailySummary = (
    state = {
        isFetching: false,
        entity: {}
    },
    action
) => {
    switch (action.type) {
        case types.REQUEST_DAILY_SUMMARY:
            return {
                ...state,
                isFetching: true
            };
        case types.RECEIVE_DAILY_SUMMARY:
            return {
                ...state,
                isFetching: false,
                entity: action.dailySummary,
                lastUpdated: action.receivedAt
            };
        default:
            return state;
    }
};

export const getDailySummary = (state) => state.dailySummary.entity;

export default dailySummary;
